import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export type EmployerSavedFilterSelectionDistanceValue = {
  placeId: string;
  lat: number;
  lng: number;
  formattedAddress: string;
  radiusInMiles: number;
};
export type EmployerSavedFilterSelectionData = {
  distance: EmployerSavedFilterSelectionDistanceValue;
  query: string;
  geographyId?: string;
  geography_id?: string;
  videoAskAnswers?: string[];
  video_ask_answers?: string[];
  jobSearchStatus?: string[];
  job_search_status?: string[];
  employmentType?: string[];
  employment_type?: string[];
  roleType?: string[];
  role_type?: string[];
  educationLevel?: string[];
  education_level?: string[];
  byMajorIn?: string[];
  by_major_in?: string[];
  workExperience?: string[];
  work_experience?: string[];
  desiredLocation?: string[];
  desired_location?: string[];
  languages?: string[];
  certifications?: string[];
  educationPhilosophy?: string[];
  recommended?: {
    jobListingId: string;
    jobListingTitle: string;
    locationId: string;
    locationName: string;
    onlyRecommended: boolean;
  };
};
export class EmployerSavedFilterSelectionAttributes {
  id: string;
  data: EmployerSavedFilterSelectionData;
  diff: string[];
  profileId: string;
  profileType: string;
  updatedAt: string;
  createdAt: string;
}

export class EmployerSavedFilterSelectionBelongsTo {}

export class EmployerSavedFilterSelectionHasOne {}

export class EmployerSavedFilterSelectionHasMany {}

/**
 * Utility interfaces
 */
export interface EmployerSavedFilterSelectionMethods {}

export interface EmployerSavedFilterSelectionInterface
  extends EmployerSavedFilterSelectionAttributes,
    EmployerSavedFilterSelectionBelongsTo,
    EmployerSavedFilterSelectionHasOne,
    EmployerSavedFilterSelectionHasMany,
    EmployerSavedFilterSelectionType {}

type EmployerSavedFilterSelectionType = GConstructor<EmployerSavedFilterSelectionInterface>;

export interface EmployerSavedFilterSelectionResource
  extends Base<EmployerSavedFilterSelectionAttributes>,
    EmployerSavedFilterSelectionInterface,
    EmployerSavedFilterSelectionMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmployerSavedFilterSelectionAttributes>({
    queryName: 'employers/saved_filter_selections',
    className: 'SavedFilterSelection',
    AttributesClass: EmployerSavedFilterSelectionAttributes,
    BelongsToClasses: [
      {
        Klass: EmployerSavedFilterSelectionBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: EmployerSavedFilterSelectionHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: EmployerSavedFilterSelectionHasMany,
      },
    ],
  });

export const EmployerSavedFilterSelectionResourceClass = <
  TBase extends EmployerSavedFilterSelectionType,
>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements EmployerSavedFilterSelectionMethods {};

export class EmployerSavedFilterSelectionResource extends ClassExtender<EmployerSavedFilterSelectionInterface>(
  BaseClass,
  EmployerSavedFilterSelectionResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerSavedFilterSelection =
  APILibrary.createResource<EmployerSavedFilterSelectionResource>(
    EmployerSavedFilterSelectionResource,
  );
